import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';
import sourceText, { SOURCE_IDS } from '../data/sourceText';
import { getAttribution } from '../utils/attribution';

var API = process.env.REACT_APP_BACKEND_URL;

// Asked once, after payment: a row of chips, no typing, no obligation.
// The silent first-touch data is posted on mount whether they answer or not.
export default function SourceChips(props) {
  var langRef = useTranslation();
  var tx = sourceText[langRef.language] || sourceText.en;
  var orderNumber = props.orderNumber;
  // Remember the answer locally so a reload doesn't ask the same person twice.
  var [picked, setPicked] = useState(function() {
    try { return localStorage.getItem('jm_attr_answer_' + orderNumber) || ''; } catch (e) { return ''; }
  });

  useEffect(function() {
    if (!orderNumber) return;
    fetch(API + '/api/attribution/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_number: orderNumber, email: props.email || null, auto: getAttribution() })
    }).catch(function() {});
  }, [orderNumber, props.email]);

  function pick(id) {
    if (picked) return;
    setPicked(id);
    try { localStorage.setItem('jm_attr_answer_' + orderNumber, id); } catch (e) {}
    fetch(API + '/api/attribution/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_number: orderNumber, email: props.email || null, answer: id })
    }).catch(function() {});
  }

  if (!orderNumber) return null;

  if (picked) {
    return (
      <div className="bg-neutral-900/70 border border-[#d4af37]/30 rounded-2xl px-6 py-5 mb-8 text-center"
           data-testid="source-chips-thanks">
        <p className="text-[#d4af37] text-sm font-semibold inline-flex items-center gap-2">
          <Check className="w-4 h-4" /> {tx.thanks}
        </p>
        <p className="text-neutral-500 text-xs mt-1">{tx[picked]}</p>
      </div>
    );
  }

  return (
    <div className="bg-neutral-900/70 border border-white/10 rounded-2xl px-6 py-5 mb-8 text-left"
         data-testid="source-chips">
      <p className="text-white text-sm font-semibold">{tx.q}</p>
      <p className="text-neutral-500 text-xs mt-1 mb-4">{tx.sub}</p>
      <div className="flex flex-wrap gap-2">
        {SOURCE_IDS.map(function(id) {
          return (
            <button key={id} onClick={function() { pick(id); }}
                    data-testid={'source-chip-' + id}
                    className="text-xs text-neutral-300 border border-white/15 rounded-full px-3.5 py-2
                               hover:border-[#d4af37] hover:text-[#d4af37] transition-colors">
              {tx[id]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
